import React, { useEffect, useState } from 'react'
import ScreeningQuestionNoView from './components/ScreeningQuestionNoView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const ScreeningQuestionNo = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('screening-question-no', 'Change of Address', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [i18n.language])

  return isError ? <Error /> : <ScreeningQuestionNoView setIsError={setIsError} />
}

export default withTranslation('common')(ScreeningQuestionNo)
